import * as React from "react";
import PreferCall from "../PreferCall";
import * as styles from "../ContactForm.module.scss";

const ContactForm = () => {
  return (
    <>
      <section className={styles.form_section}>
        <div className={styles.contact_form}>
          <form
            className={styles.form_grid}
            method="post"
            action="https://formspree.io/f/mzbyplgd"
          >
            <input
              type="text"
              name="FullName"
              placeholder="Full name*"
              required
            />
            <input
              type="text"
              name="Telephone"
              placeholder="Telephone*"
              required
            />
            <input type="email" name="Email" placeholder="Email*" required />
            <input
              type="text"
              name="_subject"
              placeholder="Company*"
              required
            />
            <textarea
              name="textarea"
              placeholder="Tell us about your project"
            />
            <input
              type="submit"
              value="Send  Now"
            ></input>
          </form>
        </div>
      </section>
      <section style={{marginTop: "50px"}}>
        <PreferCall />
      </section>
    </>
  );
};

export default ContactForm;
